import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/voting-manage',
    name: 'VotingManage',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/voting-manage/quick-image-selection/list',
    meta: {
      title: '选图管理',
    },
    children: [
      {
        path: 'quick-image-selection/list',
        name: 'VotingManageQuickImageSelectionList',
        component: () => import('./quick-image-selection/views/list/index.vue'),
        meta: {
          title: '快速选图',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'image-selection-result/list',
        name: 'VotingManageImageSelectionResultList',
        component: () => import('./image-selection-result/views/list/index.vue'),
        meta: {
          title: '选图结果',
          auth: true,
          isKeepAlive: false,
        },
      },
    ],
  },
] as IRouteConfig[];
